<ng-container *transloco="let t; read: 'definition'">
  <h1 [innerHTML]="t('title')"></h1>
  <section class="article">
    <article>
      <div class="text" [innerHTML]="t('content')"></div>
    </article>
  </section>

  <section class="blocks inverted">
    <div class="blocks">
      <article>
        <div><img src="assets/icon_kopf.png" /></div>
        <h3>{{ t("comprehensibility-title") }}</h3>
        <div>{{ t("comprehensibility-text") }}</div>
      </article>
      <article>
        <div><img src="assets/icon_team.png" /></div>
        <h3>{{ t("availability-title") }}</h3>
        <div>{{ t("availability-text") }}</div>
      </article>
      <article>
        <div><img src="assets/icon_kostenersparnis.png" /></div>
        <h3>{{ t("durability-title") }}</h3>
        <div>{{ t("durability-text") }}</div>
      </article>
    </div>
  </section>
  <section class="article">
    <article>
      <a [routerLink]="['/home']" class="call">{{ t("back-button") }}</a>
    </article>
  </section>
</ng-container>
